import React from "react";
import { Box } from "@mui/material";
import { OcChartProps } from "./chart";
import { useOcChart } from "./use-chart";
import { OcChartLegendNew } from "oc/components/chart-legend-new";
import { OcChartSummary } from "oc/components/chart-summary";
import { OcDoughnut } from "oc/components/doughnut";
import { PRODUCTS } from "oc/configs/constants";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

type OcChartViewProps = OcChartProps & ReturnType<typeof useOcChart>;

export const OcChartView: React.FC<OcChartViewProps> = ({
  chartBoxPadding,
  containerBoxPadding,
  cutout,
  data,
  size,
  summaryText,
  summaryTitle,
  variant,
  loading,
}) => {
  const isMobile = useOcIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        ...containerBoxPadding,
      }}
    >
      <Box padding={chartBoxPadding}>
        <Box position="relative">
          <OcDoughnut
            cutout={cutout}
            data={data}
            dataBorder={variant === PRODUCTS.MYCAFETERIA}
            size={size}
            loading={loading}
            tooltipEnabled={variant !== PRODUCTS.MYCAFETERIA}
          />
          <OcChartSummary
            summaryTitle={summaryTitle}
            summaryText={summaryText}
            variant={variant}
            loading={loading}
          />
        </Box>
      </Box>
      {variant !== PRODUCTS.MYTIMESHEET && (
        <Box width={isMobile ? "100%" : undefined}>
          {data?.map((item, index) => (
            <OcChartLegendNew
              data={item}
              key={item.label}
              loading={loading}
              showDivider={index < data.length - 1}
              isMobile={isMobile}
              dividerLine={variant === PRODUCTS.MYCAFETERIA}
              minWidth={variant === PRODUCTS.MYCAFETERIA ? "200px" : undefined}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
